import _ from "lodash";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useState } from "react";

import { useIntlTranslate } from "../../../../hooks";
import { useHeaderTableContext } from "../headerContextProvider";
import { Input } from "../../../input/Input";

export const TableSearch = ({ onSearchChange, value }) => {
  const translate = useIntlTranslate();

  const { getSearchInputProps } = useHeaderTableContext();

  const { globalFilter, setGlobalFilter, ariaLabelMessage } =
    getSearchInputProps();

  const [inputValue, setInputValue] = useState(globalFilter || "");
  const handleSearchChange = useCallback(
    (searchValue) => {
      onSearchChange(searchValue);
      setGlobalFilter(searchValue);
      setInputValue(searchValue);
    },
    [onSearchChange, setGlobalFilter]
  );

  useEffect(() => {
    if (_.isUndefined(value)) {
      setInputValue(globalFilter || "");

      return;
    }

    setGlobalFilter(value);
    setInputValue(value);
  }, [value, globalFilter, setGlobalFilter]);

  return (
    <Input
      value={inputValue}
      placeholder={translate("search")}
      onChange={(e) => handleSearchChange(e.target.value)}
      onClear={() => handleSearchChange("")}
      className={"table__search"}
      icon="fa-solid fa-search"
      aria-label={ariaLabelMessage && translate(ariaLabelMessage)}
    />
  );
};

TableSearch.propTypes = {
  onSearchChange: PropTypes.func,
  value: PropTypes.string,
};

TableSearch.defaultProps = {
  onSearchChange: _.noop,
};
